var _excluded = ["title", "titleId", "desc", "descId"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { forwardRef } from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgSharePeople = function SvgSharePeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    className: "bf-svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    d: "M8.327 3.91A3.502 3.502 0 0 0 1.5 5a3.501 3.501 0 0 0 6.827 1.09 3.5 3.5 0 0 0 0-2.18m-2.06 5.752A5.01 5.01 0 0 0 .18 13.17C.062 13.594 0 14.04 0 14.5h1.33a3.67 3.67 0 1 1 7.34 0H10a5 5 0 0 0-.369-1.888 5 5 0 0 0-1.518-2.025 5 5 0 0 0-1.846-.925m2.764-.043q-.121.135-.231.28l.955.956A2.67 2.67 0 0 1 12 9.63c.737 0 1.405.299 1.888.782s.782 1.15.782 1.888H16a3.995 3.995 0 0 0-4-4 4 4 0 0 0-2.969 1.32m1.662-2.487c.38.233.828.368 1.307.368A2.498 2.498 0 0 0 14.5 5a2.5 2.5 0 1 0-3.807 2.132M12 6.17a1.17 1.17 0 1 0 0-2.34 1.17 1.17 0 0 0 0 2.34m-7 1a2.17 2.17 0 1 0 0-4.34 2.17 2.17 0 0 0 0 4.34",
    clipRule: "evenodd"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSharePeople);
ForwardRef.displayName = 'SvgSharePeople';
export { ForwardRef as default };